<template>
  <p
    class="text"
    data-splitting
    v-text-observe
    v-text-animation="isAnimated">
    <slot></slot>
  </p>
</template>

<script>
import anime from 'animejs'
import Splitting from 'splitting'

export default {
  name: 'AnimatedText',
  data: () => ({
    isAnimated: false,
    words: undefined
  }),
  directives: {
    'text-observe': {
      bind (el, binding, vnode) {
        const options = {
          threshold: 0.35
        }
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !vnode.context.isAnimated) {
              vnode.context.isAnimated = true
            }
          })
        }, options)

        observer.observe(el)
      }
    },
    'text-animation': {
      bind (el, binding, vnode) {
        vnode.context.words = Splitting({
          target: el,
          by: 'words'
        })

        /* anime.set(el, {
          filter: 'blur(10px)'
        }) */
        anime.set(el.querySelectorAll('.word'), {
          // translateY: () => anime.random(-50, 50),
          opacity: 0
        })
      },
      update (el, binding, vnode) {
        if (binding.value !== binding.oldValue) {
          /* anime({
            targets: el,
            filter: 'blur(0px)',
            easing: 'cubicBezier(0.55, 0.32, 0.62, 0.87)',
            complete: () => el.classList.add('text--animated'),
            duration: 1500
          }) */
          el.querySelectorAll('.word').forEach(word => {
            anime({
              targets: word,
              opacity: 1,
              easing: 'cubicBezier(0.55, 0.32, 0.62, 0.87)',
              duration: anime.random(500, 2800)
            })
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">

@import './style.scss';

</style>
